const doNothing = (): void => {
  // do nothing
};
export default doNothing;
